export const shipmentZonesStore = {
	state: {
    	shipmentZones: {
			available: [],
			loaded: false,
			selectedIndex: null
		}	
	},

	updateAvailableShipmentZones (array, loaded) {
		this.state.shipmentZones.loaded = loaded

		return this.state.shipmentZones.available = array
	},

	selectShipmentZoneIndex (index) {
		return this.state.shipmentZones.selectedIndex = index
	}
}